import { render, staticRenderFns } from "./media-binding-list.vue?vue&type=template&id=ff5ae016"
import script from "./media-binding-list.vue?vue&type=script&lang=js"
export * from "./media-binding-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports